import { defaultBreakpoints as e } from "../constants/default-breakpoints.mjs";
import { breakpointQueries as t } from "../constants/breakpoint-queries.mjs";
import { isClient as n } from "../../../server-side/is-client.mjs";
//#region src/hooks/use-media-query/utils/get-current-breakpoints.ts
var r = () => n() ? {
	isMobile: window.matchMedia(t.isMobile).matches,
	isTablet: window.matchMedia(t.isTablet).matches,
	isDesktop: window.matchMedia(t.isDesktop).matches
} : e;
//#endregion
export { r as getCurrentBreakpoints };
